import {Directive, EmbeddedViewRef, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {TableColumn} from './table';
import {TableColumnTemplateContext} from './table-column-template-context';

@Directive({
    selector: '[tableColumn]',
    standalone: false
})
export class TableColumnDirective {

    @Input()
    public tableColumn: TableColumn | string; // string type allows to omit value in template: <td *tableColumn></td>

    constructor(
        public viewContainerRef: ViewContainerRef,
        public templateRef: TemplateRef<TableColumnTemplateContext>
    ) {}

    public render(
        viewContainerRef: ViewContainerRef,
        viewRefIndex?: number
    ): EmbeddedViewRef<TableColumnTemplateContext> {
        const context: TableColumnTemplateContext = {
            $implicit: this.tableColumn as TableColumn
        };

        return viewContainerRef.createEmbeddedView(
            this.templateRef,
            context,
            viewRefIndex
        );
    }

    public getElement(viewRef: EmbeddedViewRef<TableColumnTemplateContext>): HTMLElement {
        return viewRef.rootNodes[0];
    }

}
